module.exports = __webpack_public_path__ + "img/thumb-005-24.437eb736.png";